import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

export default function FaqItem({ item, index, openFaq, setOpenFaq }) {
  const isOpen = openFaq === index
  return (
    <div className={`border rounded-xl overflow-hidden transition-all duration-200 ${isOpen ? 'border-blue-200 bg-blue-50/50' : 'border-slate-200 bg-white hover:border-slate-300'}`}>
      <button
        onClick={() => setOpenFaq(isOpen ? null : index)}
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
      >
        <span className={`font-semibold text-base ${isOpen ? 'text-blue-900' : 'text-slate-800'}`}>
          {item.q}
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`w-5 h-5 flex-shrink-0 text-slate-400 transition-transform duration-200 ${isOpen ? 'rotate-180 text-blue-500' : ''}`}
        />
      </button>
      {isOpen && (
        <div className="px-6 pb-5">
          <p className="text-slate-600 text-sm leading-relaxed">{item.a}</p>
        </div>
      )}
    </div>
  )
}
